<!-- Breadcrumb -->
<div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
    <h5 class="mb-0">Download PDF</h5>
    <ol class="breadcrumb list-unstyled mt-0 mb-0 p-0">
        <li class="breadcrumb-item d-inline-block position-relative">
            <a routerLink="/dashboard" class="d-inline-block position-relative">
                <i class="material-symbols-outlined"> home </i>
                Dashboard
            </a>
        </li>
        <li class="breadcrumb-item d-inline-block position-relative">
            Die
        </li>
        <li class="breadcrumb-item d-inline-block position-relative">
            Download PDF
        </li>
    </ol>
</div>

<div class="crm-leads-card trezo-card mb-25 border-radius d-block bg-white border-0 shadow-none">
    <div class="trezo-card-header d-sm-flex align-items-center justify-content-between">
        <div class="trezo-card-title">
            <h5 class="mb-0">Generate PDF Report</h5>
            <p class="mb-0 mt-2 text-muted">Select categories or dies to generate a PDF report</p>
        </div>
    </div>

    <div class="trezo-card-content p-4">
        <!-- Filter Mode Selection -->
        <div class="mb-4">
            <h6 class="mb-3">Select Filter Type</h6>
            <div class="d-flex gap-3">
                <button
                    type="button"
                    class="btn fw-medium border-radius transition"
                    [class.btn-primary]="filterMode() === 'category'"
                    [class.btn-outline-secondary]="filterMode() !== 'category'"
                    (click)="setFilterMode('category')">
                    <i class="material-symbols-outlined me-2">category</i>
                    Filter by Categories
                </button>
                <button
                    type="button"
                    class="btn fw-medium border-radius transition"
                    [class.btn-primary]="filterMode() === 'die'"
                    [class.btn-outline-secondary]="filterMode() !== 'die'"
                    (click)="setFilterMode('die')">
                    <i class="material-symbols-outlined me-2">inventory_2</i>
                    Filter by Dies
                </button>
            </div>
        </div>

        <!-- Category Selection -->
        <div *ngIf="filterMode() === 'category'" class="filter-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h6 class="mb-0">Select Categories</h6>
                <div class="d-flex gap-2">
                    <button
                        type="button"
                        class="btn btn-sm btn-outline-primary"
                        (click)="selectAllCategories()">
                        Select All
                    </button>
                    <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        (click)="clearAllCategories()">
                        Clear All
                    </button>
                </div>
            </div>

            <!-- Search Box -->
            <div class="mb-3">
                <div class="position-relative">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Search categories..."
                        [(ngModel)]="categorySearchText"
                        (ngModelChange)="categorySearchText.set($event)">
                    <i class="material-symbols-outlined position-absolute" style="right: 10px; top: 50%; transform: translateY(-50%);">search</i>
                </div>
            </div>

            <!-- Category List -->
            <div class="selection-list border rounded p-3" style="max-height: 400px; overflow-y: auto;">
                <div *ngIf="getFilteredCategories().length === 0" class="text-center text-muted py-4">
                    <i class="material-symbols-outlined d-block mb-2" style="font-size: 48px;">category</i>
                    <p>No categories found</p>
                </div>
                <div
                    *ngFor="let category of getFilteredCategories()"
                    class="form-check mb-2 p-2 rounded hover-bg-light"
                    [class.bg-light]="isCategorySelected(category.id!)">
                    <input
                        class="form-check-input"
                        type="checkbox"
                        [id]="'category-' + category.id"
                        [checked]="isCategorySelected(category.id!)"
                        (change)="toggleCategorySelection(category.id!)">
                    <label
                        class="form-check-label w-100"
                        [for]="'category-' + category.id">
                        <strong>{{ category.name }}</strong>
                        <span class="text-muted ms-2" *ngIf="category.tenant">{{ category.tenant.name }}</span>
                    </label>
                </div>
            </div>

            <div class="mt-3 p-3 bg-light rounded">
                <small class="text-muted">
                    <i class="material-symbols-outlined me-1" style="font-size: 16px; vertical-align: text-bottom;">info</i>
                    Selected: <strong>{{ selectedCategoryIds().length }}</strong> categories
                </small>
            </div>
        </div>

        <!-- Die Selection -->
        <div *ngIf="filterMode() === 'die'" class="filter-section">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h6 class="mb-0">Select Dies</h6>
                <div class="d-flex gap-2">
                    <button
                        type="button"
                        class="btn btn-sm btn-outline-primary"
                        (click)="selectAllDies()">
                        Select All
                    </button>
                    <button
                        type="button"
                        class="btn btn-sm btn-outline-secondary"
                        (click)="clearAllDies()">
                        Clear All
                    </button>
                </div>
            </div>

            <!-- Search Box -->
            <div class="mb-3">
                <div class="position-relative">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Search dies by name or number..."
                        [(ngModel)]="dieSearchText"
                        (ngModelChange)="dieSearchText.set($event)">
                    <i class="material-symbols-outlined position-absolute" style="right: 10px; top: 50%; transform: translateY(-50%);">search</i>
                </div>
            </div>

            <!-- Die List -->
            <div class="selection-list border rounded p-3" style="max-height: 400px; overflow-y: auto;">
                <div *ngIf="getFilteredDies().length === 0" class="text-center text-muted py-4">
                    <i class="material-symbols-outlined d-block mb-2" style="font-size: 48px;">inventory_2</i>
                    <p>No dies found</p>
                </div>
                <div
                    *ngFor="let die of getFilteredDies()"
                    class="form-check mb-2 p-2 rounded hover-bg-light d-flex align-items-center"
                    [class.bg-light]="isDieSelected(die.id!)">
                    <input
                        class="form-check-input me-2"
                        type="checkbox"
                        [id]="'die-' + die.id"
                        [checked]="isDieSelected(die.id!)"
                        (change)="toggleDieSelection(die.id!)">
                    <img
                        *ngIf="die.photoUrl"
                        [src]="getImageUrl(die.photoUrl)"
                        alt="Die Photo"
                        class="rounded me-2"
                        style="width: 100px; height: 100px; object-fit: cover;">
                    <label
                        class="form-check-label flex-grow-1"
                        [for]="'die-' + die.id">
                        <strong>{{ die.name }}</strong>
                        <span class="text-muted ms-2">({{ die.no }})</span>
                        <br>
                        <small class="text-muted" *ngIf="die.category">{{ die.category.name }}</small>
                    </label>
                </div>
            </div>

            <div class="mt-3 p-3 bg-light rounded">
                <small class="text-muted">
                    <i class="material-symbols-outlined me-1" style="font-size: 16px; vertical-align: text-bottom;">info</i>
                    Selected: <strong>{{ selectedDieIds().length }}</strong> dies
                </small>
            </div>
        </div>

        <!-- Generate Button -->
        <div class="mt-4 d-flex justify-content-end gap-3">
            <button
                type="button"
                class="btn btn-outline-secondary fw-medium border-radius"
                routerLink="/dashboard/die">
                <i class="material-symbols-outlined me-2">arrow_back</i>
                Back to Die List
            </button>
            <button
                type="button"
                class="btn btn-primary fw-medium border-radius"
                (click)="generatePDF()"
                [disabled]="(filterMode() === 'category' && selectedCategoryIds().length === 0) ||
                           (filterMode() === 'die' && selectedDieIds().length === 0)">
                <i class="material-symbols-outlined me-2">picture_as_pdf</i>
                Generate PDF
            </button>
        </div>
    </div>
</div>
